import { useMemo } from "react";

import moment from "moment-timezone";

import appStore from "stores/app";

export function useEntity(entityId, entityName, entityCollection) {
  const { version: { item } } = entityCollection

  const currentId = useMemo(() => {
    if (item) {
      return item.id
    }

    return entityId
  }, [entityId, item])

  const currentName = useMemo(() => {
    if (item) {
      return "versions"
    }

    return entityName
  }, [entityName, item])

  return useMemo(() => ({
    id: currentId,
    name: currentName,
  }), [currentId, currentName])
}

export function useGrouping(versions) {
  return useMemo(() => {
    const groups = {}
    const parsed = []
    const now = moment().tz(appStore.timezone)

    const rangeMinutes = now.clone().subtract(15, "minutes")
    const rangeHour = now.clone().subtract(1, "hour")
    const rangeToday = now.clone().startOf("day")
    const rangeYesterday = now.clone().subtract(1, "day").startOf("day")
    const rangeWeek = now.clone().subtract(1, "week")
    const rangeMonth = now.clone().subtract(1, "month")
    const rangeYear = now.clone().subtract(1, "year")
    const range5Years = now.clone().subtract(5, "years")

    const lastMinutes = date => date.isAfter(rangeMinutes)
    const lastHour = date => date.isAfter(rangeHour)
    const today = date => date.isSame(rangeToday, "day")
    const yesterday = date => date.isSame(rangeYesterday, "day")
    const lastWeek = date => date.isAfter(rangeWeek)
    const lastMonth = date => date.isAfter(rangeMonth)
    const lastYear = date => date.isAfter(rangeYear)
    const last5Years = date => date.isAfter(range5Years)

    const set = (group, version) => groups[group] ? groups[group].push(version) : groups[group] = [version]

    for (const version of versions) {
      const date = moment(version.createdAt).tz(appStore.timezone)
      if (lastMinutes(date)) set("Now", version)
      else if (lastHour(date)) set("Last hour", version)
      else if (today(date)) set("Today", version)
      else if (yesterday(date)) set("Yesterday", version)
      else if (lastWeek(date)) set("Last week", version)
      else if (lastMonth(date)) set("Last month", version)
      else if (lastYear(date)) set("Last year", version)
      else if (last5Years(date)) set("Last 5 years", version)
      else set("All time", version)
    }

    for (const [group, versions] of Object.entries(groups)) {
      if (versions.length) {
        parsed.push({ group, versions })
      }
    }

    return parsed
  }, [versions])
}
